import React, { lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const config = {
    showedTabs: { Signal: true, Wf: false, Package: false },
    pageTitle: 'Signals',
    persistName: 'signal-list-storage',
    removeItemText: 'Are you sure you want to delete the signal?',
};

const ComponentList = lazy(() => import('../Components/List'));
const SignalAddEditFormContainer = lazy(() => import('../Components/SignalAddEditForm'));
const Import = lazy(() => import('../Components/Import'));

export const SignalsRoutes = () => {
    return (
        <Routes>
            <Route path="signals" element={<ComponentList {...config} />} />
            <Route path="signals/edit/:name" element={<SignalAddEditFormContainer />} />
            <Route path="signals/create" element={<SignalAddEditFormContainer />} />
            <Route path="signals/import" element={<Import pageTitle="Import signal" backTitle="signals" />} />

            <Route path="*" element={null} />
        </Routes>
    );
};
